"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolsModeReducer = exports.toggleDetailedModel = exports.toggleCutLineDrawn = exports.setActiveStickyID = exports.toggleOptionsExpanded = exports.ToolsModeActionType = void 0;
const react_1 = require("react");
var ToolsModeActionType;
(function (ToolsModeActionType) {
    ToolsModeActionType["ToggleOptionsExpanded"] = "toggleOptionsExpanded";
    ToolsModeActionType["SetActiveStickyID"] = "setActiveStickyID";
    ToolsModeActionType["ToggleCutLineDrawn"] = "toggleCutLineDrawn";
    ToolsModeActionType["ToggleDetailedModel"] = "toggleDetailedModel";
})(ToolsModeActionType || (exports.ToolsModeActionType = ToolsModeActionType = {}));
const toggleOptionsExpanded = (isExpanded) => ({
    type: ToolsModeActionType.ToggleOptionsExpanded,
    payload: isExpanded,
});
exports.toggleOptionsExpanded = toggleOptionsExpanded;
const setActiveStickyID = (identifier) => ({
    type: ToolsModeActionType.SetActiveStickyID,
    payload: identifier,
});
exports.setActiveStickyID = setActiveStickyID;
const toggleCutLineDrawn = (isDrawn) => ({
    type: ToolsModeActionType.ToggleCutLineDrawn,
    payload: isDrawn,
});
exports.toggleCutLineDrawn = toggleCutLineDrawn;
const toggleDetailedModel = (isDetailedModel) => ({
    type: ToolsModeActionType.ToggleDetailedModel,
    payload: isDetailedModel,
});
exports.toggleDetailedModel = toggleDetailedModel;
function toolsModeReducer(state, action) {
    const { type, payload } = action;
    switch (type) {
        case ToolsModeActionType.ToggleOptionsExpanded:
            return Object.assign(Object.assign({}, state), { isOptionsExpanded: payload });
        case ToolsModeActionType.SetActiveStickyID:
            return Object.assign(Object.assign({}, state), { activeStickyID: payload });
        case ToolsModeActionType.ToggleCutLineDrawn:
            return Object.assign(Object.assign({}, state), { isCutLineDrawn: payload });
        case ToolsModeActionType.ToggleDetailedModel:
            return Object.assign(Object.assign({}, state), { isDetailedModel: payload });
        default:
            return state;
    }
}
exports.toolsModeReducer = toolsModeReducer;
function useToolsModeReducer(state) {
    return (0, react_1.useReducer)(toolsModeReducer, state);
}
exports.default = useToolsModeReducer;
